<template>
    <main>
        <h1>Catégories</h1>
        
        <section class="categories">
            <div class="categorie">
                <h2>Clickers</h2>
                <div class="all-games">
                    <div class="jeu-container" v-for="i in 6" :key="i">
                        <div class="jeu">
                            <a>
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="categorie">
                <h2>Réflexion</h2>
                <div class="all-games">
                    <div class="jeu-container" v-for="i in 6" :key="i">
                        <div class="jeu">
                            <a>
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="categorie">
                <h2>Action</h2>
                <div class="all-games">
                    <div class="jeu-container" v-for="i in 6" :key="i">
                        <div class="jeu">
                            <a>
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="categorie">
                <h2>Course</h2>
                <div class="all-games">
                    <div class="jeu-container" v-for="i in 6" :key="i">
                        <div class="jeu">
                            <a>
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    export default {
        name: 'SkeletonCategories'
    }
</script>

<style scoped src="@/assets/categories.css">
</style>
<style scoped src="@/assets/skeletonCategories.css">
</style>